/* eslint-disable import/first */
import React, { useEffect } from 'react';
import { Redux, Slices } from 'spwa-ui-library';
import { useLocation, useNavigate } from '@reach/router';
import { useIntl, FormattedMessage } from 'react-intl';
import Hreflang from '../../components/Hreflang';
import { getSortedWidget } from 'spwa-ui-library/esm/utils/helper';
import ContentSection from '../../components/ContentSection';
import Header from '../../components/Header';
import OrderModesBar from '../../components/OrderModesBar';
import LanguageButton from '../../components/LanguageButton';
import SideMenu from '../../components/SideMenu';
import AddressSelector from '../../components/AddressSelector';
import BannerMedium from '../../components/BannerMedium';
import PizzaHutFooter from '../../components/PizzaHutFooter';
import Video from '../../components/Video';
import QrCodeRender from '../../components/QrCodeRender';
import ExploreMenuHome from '../../components/ExploreMenuHome';
import SeoTitle from '../../components/SeoTitle';
import css from './index.module.scss';
import HomeSkeleton from '../../components/HomeSkeleton';
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import Button from '@material-ui/core/Button';
import SwipeableViews from 'react-swipeable-views';
import { BiRightArrowCircle } from '@react-icons/all-files/bi/BiRightArrowCircle';
import { BiLeftArrowCircle } from '@react-icons/all-files/bi/BiLeftArrowCircle';
const { useSelector, useDispatch } = Redux;
const { fetchProductsByCategoryId, selectProductFetchStatus } = Slices.productSlice;
const { setQRValues, getQRValue, selectDesktop, qrCodeStatus } = Slices.appSlice;
const { fetchCategoryStatus, selectFirstCategory } = Slices.categorySlice;
const { fetchHome, selectHomeData, selectHomeStatus } = Slices.homeSlice;
// import CurrentOrderDesktop from '../../components/CurrentOrderDesktop';
// import EasyOrderDesktop from '../../components/EasyOrderDesktop';
const { selectLoginStatus } = Slices.authSlice;
const { selectCurrentCountry, selectProfileStatus } = Slices.profileSlice;
const { selectMenuStatus } = Slices.menuSlice;
const { selectConfigStatus, selectCountryValidations, getClusterId } = Slices.configSlice;
// const { getOrder } = Slices.orderSlice;

function Home({ path }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const intl = useIntl();
  const loginStatus = useSelector(selectLoginStatus);
  const isDesktop = useSelector(selectDesktop);
  const clusterId = useSelector(getClusterId);
  const homeStatus = useSelector(selectHomeStatus);
  const menuStatus = useSelector(selectMenuStatus);
  const configStatus = useSelector(selectConfigStatus);
  const profileStatus = useSelector(selectProfileStatus);
  const qrValue = useSelector(getQRValue);
  const homeData = useSelector(selectHomeData);
  const currentCountry = useSelector(selectCurrentCountry);
  const [pageState, setPageState] = React.useState('initial');
  const [qrDrawer, setQrDrawer] = React.useState(false);
  const [alertStatus, setAlertStatus] = React.useState(false);
  const categoryStatus = useSelector(fetchCategoryStatus);
  const productStatus = useSelector(selectProductFetchStatus);
  const firstCategory = useSelector(selectFirstCategory);
  const [currentSlider, setCurrentSlider] = React.useState(0);
  const countryValidations = useSelector((state) =>
    selectCountryValidations(state, currentCountry)
  );
  const axis = intl.locale === 'ar' ? 'x-reverse' : 'x';

  useEffect(() => {
    const { storeId, type, countryId, extraDetails = '' } = Object.fromEntries(
      new URLSearchParams(location.search || '')
    );
    if (storeId && type && countryId && qrValue.status !== 'added') {
      dispatch(setQRValues({ storeId, type, countryId, extraDetails }));
      navigate(`/${intl.locale.toLowerCase()}/home`, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);
  const addressObj = window.localStorage.getItem('_add')
    ? JSON.parse(window.localStorage.getItem('_add'))
    : '';
  const multiCluster = Object.entries(addressObj).length ? addressObj.clusterId : clusterId;
  useEffect(() => {
    if (
      !isDesktop &&
      !qrDrawer &&
      qrValue.status === 'added' &&
      homeStatus === 'succeeded' &&
      configStatus === 'succeeded'
    ) {
      setQrDrawer(true);
    }
  }, [configStatus, homeStatus, isDesktop, qrDrawer, qrValue.status]);

  useEffect(() => {
    const v = process.env.REACT_APP_BFF_API_VERSION === 'v20' ? true : menuStatus === 'succeeded';
    if (
      configStatus === 'succeeded' &&
      homeStatus === 'idle' &&
      // v &&
      // pageState === 'initial' &&
      profileStatus === 'succeeded'
    ) {
      const homePayload = {
        // country: currentCountry.toLowerCase(),
        // lang: intl.locale,
        cluster: multiCluster,
      };
      dispatch(fetchHome(homePayload));
      setPageState(() => 'loaded');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [homeStatus, configStatus, multiCluster, menuStatus, pageState, profileStatus]);

  useEffect(() => {
    if (
      firstCategory &&
      firstCategory?.id &&
      categoryStatus === 'succeeded' &&
      productStatus === 'idle'
    ) {
      dispatch(
        fetchProductsByCategoryId({
          id: firstCategory?.id,
          cluster: multiCluster,
          Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
        })
      );
    }
  }, [categoryStatus, multiCluster, firstCategory, intl.locale, productStatus, dispatch]);

  const days = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];

  const checkIfInsideTiming = (startTime, endTime) => {
    let date = new Date(
      new Date().toLocaleString('en-US', { timeZone: countryValidations?.timezone, hour12: true })
    );
    let start = startTime.split(':');
    let end = endTime.split(':');

    const startDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      parseInt(start[0]),
      parseInt(start[1]),
      0
    );

    const endDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      parseInt(end[0]),
      parseInt(end[1]),
      0
    );

    return startDate.getTime() <= date.getTime() && date.getTime() <= endDate.getTime();
  };

  const defaultTimings = { from: '00:00', to: '00:00' };
  const currentDayOfWeek =
    days[
      new Date(
        new Date().toLocaleString('en-US', {
          timeZone: countryValidations?.timezone,
          hour12: true,
        })
      ).getDay()
    ];

  const checkIfAvil = (displayDays) => {
    let isItemAvailable = true;
    if (Object.values(displayDays || {}).length === 0) {
      isItemAvailable = true;
    } else {
      const dayTimings = displayDays?.[currentDayOfWeek] || defaultTimings;
      let dealFallsInTiming = false;

      for (let timing of Array.isArray(dayTimings)
        ? dayTimings
        : Object.keys(dayTimings || {}).length > 0
        ? [dayTimings]
        : []) {
        if (checkIfInsideTiming(timing?.from, timing?.to)) {
          dealFallsInTiming = true;
          break;
        }
      }
      if (!dealFallsInTiming) {
        isItemAvailable = false;
      }
    }
    return isItemAvailable;
  };
  const getSortedWidgetNew = (widgets) => {
    let bannerMedium = [];
    widgets.forEach((widget) => {
      if (
        widget.widgetType === 'BANNER_MEDIUM'
        // ||
        // widget.widgetType === "BANNER_SMALL" ||
        // widget.widgetType === "BANNER_VIDEO"
      ) {
        if (widget.media.length > 1) {
          widget.media.forEach((val, idx) => {
            const isAvailable = checkIfAvil(val.displayDay);
            if (isAvailable) {
              const newWidget = {
                ...widget,
                media: [val],
              };
              bannerMedium.push(newWidget);
            }
          });
        } else {
          bannerMedium.push(widget);
        }
      }
    });
    return bannerMedium;
  };
  let bannerMedium = getSortedWidgetNew(homeData || []);

  const handleClosingQR = (isOrderModeDisable) => {
    if (isOrderModeDisable) {
      setAlertStatus(true);
    }
    setTimeout(() => {
      dispatch(qrCodeStatus({ status: 'shown' }));
      setQrDrawer(false);
    }, 10);
  };

  useEffect(() => {
    const yHeightScroll = localStorage.getItem('yHeightScroll');
    if (yHeightScroll) {
      window.scrollBy(0, yHeightScroll);
      localStorage.removeItem('yHeightScroll');
    }
  }, []);

  const maxSteps = bannerMedium?.length;
  const handleNext = () => {
    if (currentSlider + 2 <= maxSteps) {
      setCurrentSlider((prv) => prv + 1 - 0.5);
      // debugger;
    } else {
      setCurrentSlider((prv) => 0);
    }
  };
  const handleBack = () => {
    if (currentSlider !== 0) {
      setCurrentSlider(0);
    }
  };
  return (
    <div className={css.root}>
      <Hreflang page={'home'} />
      <h1 className="hideIt">
        <FormattedMessage id="home_h1" /> {currentCountry}
      </h1>
      <Snackbar
        open={alertStatus}
        onClose={() => setAlertStatus(false)}
        autoHideDuration={6000}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Alert onClose={() => setAlertStatus(false)} severity="error" sx={{ width: '100%' }}>
          <FormattedMessage
            id="order_mode_not_available"
            defaultMessage="This order mode is currently not available on the App."
          />
        </Alert>
      </Snackbar>
      <SeoTitle id="home" />
      <Header
        page="home"
        icon={<SideMenu />}
        title={<AddressSelector />}
        secondaryBar={<OrderModesBar />}
        actionButtons={[<LanguageButton />]}
      />
      <main className={css.main}>
        {homeData?.length === 0 || homeStatus === 'loading' ? <HomeSkeleton /> : ''}
        {homeData &&
          homeData?.map((widget) => (
            <>
              <ContentSection key={widget?.id} widgetData={widget} />
            </>
          ))}

        <div className={css.desktopBanners}>
          <SwipeableViews
            enableMouseEvents={false}
            slideClassName={css.bannerItemContainer}
            className={css.container}
            index={currentSlider}
            onChangeIndex={handleNext}
            axis={axis}
          >
            {bannerMedium &&
              bannerMedium.map((widget, i) => {
                if (widget.widgetType === 'BANNER_VIDEO') {
                  return <></>;
                  // return <Video key={i} widgetData={widget} />;
                }
                if (widget.widgetType === 'BANNER_EXTRA') {
                  return <ExploreMenuHome key={i} widgetData={widget} />;
                }
                return <BannerMedium key={i} widgetData={widget} />;
              })}
          </SwipeableViews>
          <div className={css.pagination}>
            <Button
              disabled={bannerMedium.length > 2 ? currentSlider > 0 : true}
              onClick={handleNext}
            >
              <BiRightArrowCircle />
            </Button>
            <Button disabled={currentSlider === 0} onClick={handleBack}>
              <BiLeftArrowCircle />
            </Button>
          </div>
        </div>

        {homeStatus === 'succeeded' && configStatus === 'succeeded' && qrDrawer && (
          <QrCodeRender onClose={handleClosingQR} />
        )}
      </main>
      {/* <div className={css.desktopBanners}>
          {bannerMedium &&
            bannerMedium.slice(0, 2).map((widget, i) => {
              if (widget.widgetType === 'BANNER_VIDEO') {
                return <Video key={i} widgetData={widget} imgBaseUrl={imgBaseUrl} />;
              }
              if (widget.widgetType === 'BANNER_EXTRA') {
                return <ExploreMenuHome key={i} widgetData={widget} imgBaseUrl={imgBaseUrl} />;
              }
              return <BannerMedium key={i} widgetData={widget} imgBaseUrl={imgBaseUrl} />;
            })}
        </div> */}
      <PizzaHutFooter />
    </div>
    //{' '}
  );
}

export default Home;
